import { clone } from '@/common/js/just.js'

/**
 * @description: 打开修改计划总预算弹窗
 * @param {*} rowIndex // 单条修改时的行索引
 * @return {*}
 */
export function onConvertModify(rowIndex) {
  // 点击单行时设置check状态
  if (!Object.is(Number(rowIndex), NaN)) {
    this.tableData = this.tableData.map((row, index) => {
      if (index === rowIndex) {
        return { ...row, convertCheck: true }
      }

      return row
    })
  } else {
    if (!this.tableData.some((row) => row.convertCheck)) {
      return this.$Message.warning('请选择修改行')
    }
  }
  // 保存当前需要更改的行，如果是全选更改，那么保存第一个
  this.currentModifyTableRow = clone(this.tableData[rowIndex || 0])
  this.modal.showGlobalConvertModify = true
}

/**
 * @description: 更换总预算确认
 * @param {*} convertForm {}
 * @return {*}
 */
export function onConvertModifyConfirm(convertForm) {
  if (convertForm) {
    this.tableData = this.tableData.map((row) => {
      if (row.convertCheck) {
        const newRow = clone(row)
        newRow.bid = { ...newRow.bid, ...convertForm }
        return newRow
      }

      return row
    })
  }

  this.onModifyModalCancel()
}
